import React, { useState } from 'react';
import styled from 'styled-components';
import {
    ProfileImage,
    SkillTitle,
    ContentIntoduce,
    QuestionContainer,
    QuestionImage,
    EducationText,
    EducationSubText,
    SkillText,
    CustomProgressBar,
} from '../../Introduce';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Tooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

const TitleText = styled.div`
    font-weight: 500;
    font-size: large;
    text-align: left;
    margin-top: 4%;
`;
const Container = styled.div`
    height: auto;
    width: 100vw;
`;

const InnerContainer = styled.div`
    border-radius: 20px;

    border: 1px solid #c1c1c1;
    position: relative;

    width: 95%;

    background-color: white;
    padding: 20px;
    margin-bottom: 4%;
`;

const SkillItem = ({ skill, now }) => {
    let skillText;
    if (Array.isArray(skill)) {
        skillText = skill.map((text, index) => (
            <React.Fragment key={index} style={{ textAlign: 'center' }}>
                {text}
                <br />
            </React.Fragment>
        ));
    } else {
        skillText = skill;
    }

    return (
        <div style={{ display: 'flex', alignItems: 'center', marginTop: '25px' }}>
            <SkillText style={{ fontSize: '10px' }}>{skillText}</SkillText>
            <CustomProgressBar style={{ width: '60%' }} animated now={now} />
        </div>
    );
};

const MobileIntroduce = () => {
    const [ButtonState, setButton] = useState('PROFILE');
    const [key, setKey] = useState('home');
    return (
        <Container>
            <div style={{ display: 'flex' }}>
                <ProfileImage alt="ProfileImage" src="images/profileImage.png" />

                <div
                    style={{
                        paddingTop: '20%',
                    }}
                >
                    {/* <TitleText> 김재정</TitleText>
                    <TitleText> 1997.10.23</TitleText> */}
                </div>
            </div>
            <div style={{ paddingLeft: '8%' }}>
                <div style={{ paddingTop: '5%', width: '100%', fontWeight: '400' }}>
                    React를 기반으로 한 웹/앱 프론트엔드 개발자로서, <br />
                    <text style={{ color: '#FFA500', fontWeight: '500' }}>사용자 중심의 설계</text>와 구현에 주력하며,{' '}
                    <br /> <br /> 깊은 기술 이해와 다양한 프로젝트 경험을 바탕으로 직관적이고 <br /> 매력적인 사용자
                    경험을 제공하는 것을 목표로 삼고 있습니다. <br /> <br /> UI 구현 및 프로젝트 리더십 경험을 통해{' '}
                    <br /> 효과적인 프로젝트 수행 능력을 갖추었으며, <br />{' '}
                    <text style={{ color: '#FFA500' }}> 다부서 협업을 통해 함께 일하고 성장하는 팀원</text>으로 소속되고
                    싶습니다.
                </div>
                <div style={{ marginTop: '5%' }}>
                    <SkillTitle
                        style={{ color: ButtonState == 'PROFILE' ? '#005eff' : 'gray' }}
                        onClick={() => setButton('PROFILE')}
                    >
                        PROFILE
                    </SkillTitle>
                    {ButtonState == 'PROFILE' ? (
                        <InnerContainer>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                                <ContentIntoduce>
                                    <QuestionContainer>
                                        <QuestionImage alt="question" src="images/id-cards.png" />
                                    </QuestionContainer>
                                    KIM JAE JUNG
                                </ContentIntoduce>

                                <ContentIntoduce>
                                    <QuestionContainer>
                                        <QuestionImage alt="question" src="images/calendar.png" />
                                    </QuestionContainer>
                                    1997.10.23
                                </ContentIntoduce>

                                <ContentIntoduce>
                                    <QuestionContainer>
                                        <QuestionImage alt="question" src="images/call.png" />
                                    </QuestionContainer>
                                    010 6305 0205
                                </ContentIntoduce>

                                <ContentIntoduce>
                                    <QuestionContainer>
                                        <QuestionImage alt="question" src="images/letter.png" />
                                    </QuestionContainer>
                                    wowjd2524@gmail.com
                                </ContentIntoduce>
                                <ContentIntoduce>
                                    <QuestionContainer>
                                        <QuestionImage alt="question" src="images/github.png" />
                                    </QuestionContainer>
                                    <a href="https://github.com/baebang" target="_blank" style={{ color: 'black' }}>
                                        GITHUB
                                    </a>
                                </ContentIntoduce>
                            </div>
                        </InnerContainer>
                    ) : null}
                    <SkillTitle
                        style={{ color: ButtonState == 'EDUCATION' ? '#005eff' : 'gray' }}
                        onClick={() => setButton('EDUCATION')}
                    >
                        EDUCATION / CAREER
                    </SkillTitle>
                    {ButtonState == 'EDUCATION' ? (
                        <InnerContainer>
                            <EducationText>2023.02 - 2023.08</EducationText>
                            <EducationText>
                                KAIST SW 아카데미 정글
                                <a
                                    href="https://drive.google.com/file/d/1oxzb0sn4KPOBK4xuDhQ0eLSznSlCOmLs/view?usp=sharing"
                                    target="_blank"
                                >
                                    (수료)🔗
                                </a>
                            </EducationText>
                            <EducationSubText>: KAIST PintOS 프로젝트 참여</EducationSubText>
                            <EducationSubText>: Red-Black tree / malloc / 웹서버 C언어 프로젝트</EducationSubText>

                            <EducationText style={{ marginTop: '4%' }}>2022.09 - 2022.12</EducationText>
                            <EducationText>영어 교육 플랫폼 튜터링 프론트엔드</EducationText>
                            <EducationText style={{ marginTop: '4%' }}>2019.02 - 2023.03</EducationText>
                            <EducationText>명지대학교 컴퓨터공학과 (졸업)</EducationText>
                            <EducationText style={{ marginTop: '4%' }}>2015.09 - 2019.01</EducationText>
                            <EducationText>넥슨 네트웍스 라이브실 QA (마비노기 영웅전)</EducationText>
                        </InnerContainer>
                    ) : null}
                    <SkillTitle
                        style={{ color: ButtonState == 'SKILL' ? '#005eff' : 'gray' }}
                        onClick={() => setButton('SKILL')}
                    >
                        SKILL
                        <QuestionContainer style={{ marginLeft: '3%' }}>
                            <QuestionImage
                                style={{ marginBottom: '30%' }}
                                data-tooltip-id="my-tooltip"
                                data-tooltip-html="<p>WEB으로 접속하시면 <br/>더 자세한 기술 활용 능력을 확인하실 수 있습니다.</p>"
                                alt="question"
                                src="images/question-mark.png"
                            />
                        </QuestionContainer>
                    </SkillTitle>
                    <Tooltip id="my-tooltip" />
                    {ButtonState == 'SKILL' ? (
                        <InnerContainer>
                            <Tabs
                                id="controlled-tab-example"
                                activeKey={key}
                                onSelect={(k) => {
                                    setKey(k);
                                }}
                                className="mb-3"
                                style={{ fontSize: '13px' }}
                            >
                                <Tab eventKey="home" title="FE">
                                    <SkillItem skill="React" now="90" />

                                    <SkillItem skill="React-Native" now="74" />

                                    <SkillItem skill="React-Query" now="80" />
                                    <SkillItem skill="JS" now="80" />
                                </Tab>

                                <Tab eventKey="publishing" title="PUBLISHING">
                                    <SkillItem skill="HTML" now="75" />

                                    <SkillItem skill="SCSS/CSS3" now="60" />
                                </Tab>
                                <Tab eventKey="backend" title="ETC">
                                    <SkillItem skill="Git" now="85" />

                                    <SkillItem skill="Figma/Slack/Jira" now="65" />

                                    <SkillItem skill="Communication" now="100" />
                                </Tab>
                            </Tabs>
                        </InnerContainer>
                    ) : null}
                </div>
            </div>
        </Container>
    );
};

export default MobileIntroduce;
